// extracted by mini-css-extract-plugin
export default {"form":"il8LlXGbzfaVeiEkLS8q","wrap":"EQN7f3Pqml6xEIxWYzIV","icon":"V1VDsbIfx1JLWc9ubSMA","input":"TlJ3wqf4Dn2mH2j4CsEX"};